<template>
  <expandable-container>
    <div style="font-size: 0.75rem">
      <created-properties
        v-if="event === 'created'"
        :properties="properties"
        :relations="relations"
        :resource-type="resourceType"
        :meta="meta"
      ></created-properties>
      <updated-properties
        v-else-if="event === 'updated'"
        :properties="properties"
        :relations="relations"
        :resource-type="resourceType"
        :meta="meta"
      ></updated-properties>
      <media-changed-properties
        v-else-if="event.substring(0, 6) === 'media-'"
        :meta="meta"
        :properties="properties"
        :relations="relations"
        :resource-type="resourceType"
      ></media-changed-properties>
    </div>
  </expandable-container>
</template>

<script>
import CreatedProperties from './CreatedProperties';
import UpdatedProperties from './UpdatedProperties';
import ExpandableContainer from '../Container/ExpandableContainer.vue';
import MediaChangedProperties from './MediaChangedProperties';

export default {
  components: {
    MediaChangedProperties,
    ExpandableContainer,
    UpdatedProperties,
    CreatedProperties,
  },
  props: {
    event: { type: String, default: () => 'updated' },
    properties: { type: Object, default: () => {} },
    relations: { type: Object, default: () => {} },
    resourceType: { type: String, default: () => '' },
    meta: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
